import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get paymentVoucher
export const getPaymentVoucher = createAsyncThunk(
  "paymentVoucher/getPaymentVoucher",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    try {
      const { data } = await API.getPaymentVoucher({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all paymentVoucher
export const getAllPaymentVoucher = createAsyncThunk(
  "paymentVoucher/getAllPaymentVoucher",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllPaymentVoucher();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("paymentVoucher/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("paymentVoucher/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "paymentVoucher/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPagePaymentVoucher({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get item by id
export const getPaymentVoucherById = createAsyncThunk(
  "paymentVoucher/getPaymentVoucherById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getPaymentVoucherById(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create paymentVoucher
export const createPaymentVoucher = createAsyncThunk(
  "paymentVoucher/createPaymentVoucher",
  async (createData, { rejectWithValue }) => {
    const {
      voucherType,
      voucherDetails,
      reference,
      date,
      narration,
      paymentVoucherDate,
      paymentVoucherDateBs,
      paymentVoucherType,
    } = createData;
    try {
      const body = JSON.stringify({
        voucherType,
        voucherDetails,
        reference,
        date,
        narration,
        paymentVoucherDate,
        paymentVoucherDateBs,
        paymentVoucherType,
      });

      const { data } = await API.createPaymentVoucher(body);

      //     // const

      // for (const detail of costCenterDetails) {
      //   await API.createCostCenterDetails(JSON.stringify(detail));
      // }
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
export const updatePaymentVoucher = createAsyncThunk(
  "paymentVoucher/updatePaymentVoucher",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const {
      paymentVoucherDetails,
      reference,
      date,
      narration,
      paymentVoucherDate,
      paymentVoucherDateBs,
      paymentVoucherType,
    } = values;
    try {
      const body = JSON.stringify({
        paymentVoucherDetails,
        reference,
        date,
        narration,
        paymentVoucherDate,
        paymentVoucherDateBs,
        paymentVoucherType,
      });
      const { data } = await API.updatePaymentVoucher(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const approvePaymentVoucher = createAsyncThunk(
  "paymentVoucher/approvePaymentVoucher",
  async (id, { rejectWithValue }) => {
    try {
      const body = JSON.stringify({
        approved: true,
      });
      const { data } = await API.approvePaymentVoucher(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk(
  "paymentVoucher/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
